import FolhaColaboradoresList from "../../components/folha-pagamento/colaboradores/FolhaColaboradoresList";

export default function () {
  return <FolhaColaboradoresList />;
}